import { useState } from 'react';
import './App.css';

const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxgLQcbs3J6fZzkxj9qMXGokmoVK_zRsTGmH8_rVpMrbf4-qTQR2GAAGBvfvmLQiyZzsg/exec';


const GROUPS = {
  'ФМО(И)-1-24': [
    'Абдуллаева Роза Абдумиталиповна',
    'Абдурайимен Счаткало Нормат угли',
    'Абдыкалыкова Айзирек Алмазбековна',
    'Абдыманнапова Адина Кубанычбековна',
    'Айдаралиев Илимбек Ууланбекович',
    'Алишер кызы Феруза',
    'Ибрагимова Севинч Равшанбековна',
    'Исакова Асема Кубатбековна',
    'Кадыралиева Керээз Каныбековна',
    'Маматысакова Перизат Адихомовна',
    'Махмуджонов Муртозо Муроджонович',
    'Мухамедкадыр кызы Пурдана',
    'Салиева Толгонай Абдирашидовна',
    'Тулабоева Хушноза Турабоевна',
    'Тургунбаева Алтынай Жыргалбаевна',
    'Саламат',
    'Зубайр',
  ],
  'ПИ-1-25': [
    'Абдыхалилов Иляз Тайпрович',
    'Акбарова Анара Бактияровна',
    'Алимкулова Мээримай Бактияровна',
    'Амангелдиев Нурислан Алтынбекович',
    'Бадиева Акылай Мыктыбековна',
    'Бегимкулов Маратбек Нориманжонович',
    'Жанибени Дастаи Рустамович',
    'Жоробаева Асема Нурбековна',
    'Жумабаева Айтурган Нурбековна',
    'Кадырбекова Нурзат Тынчыбековна',
    'Каримова Эхтибархон Алишеровна',
    'Касымова Нуржамал Зайирбековна',
    'Кутбидинова Биназир Авазбековна',
    'Кутбидинова Нуузат Асилбековна',
    'Мажитов Элчинбек',
    'Мамазаирова Бактыгул Абибиллаевна',
    'Нурмаматов Нурсултан Нургазыевич',
    'Позилова Захрохон',
    'Сахобиддинова Диёра Камолиддиновна',
    'Тойчуева Аяна Багышбековна',
    'Тологонова Айтурган Турдумаматовна',
    'Тополонова Доолоткан Алмазбековна',
    'Тургуналиева Асема',
    'Уранмжанова Айжан Султайбекова',
    'Хомиджонов Бехрузбек Умиджонович',
  ],
  'БУА-1-24': [
    'Абдивалиев Тимурлан Газыбекович',
    'Абдыкадыров Самарбек Санжарбекович',
    'Атабек кызы Айдана',
    'Аттокуров Ринат Замирбекович',
    'Батырбек',
    'Бегижанов Хожиакбар Рустамович',
    'Бекболотов Нурболот Бекболотович',
    'Жоошбенналы Зейнеп',
    'Имамидинова Азиза Нурланбековна',
    'Мукимжанова Сугдиёна Мансуровна',
    'Нийматжонова Бегайым Сайдиллаевна',
    'Октамжанова Мадина Бахадржановна',
    'Орунбаева Кайыргул Нурмахаматовна',
    'Сарыбаев Чубак',
    'Самиев Лутфилла Ширинбекович',
    'Сотибаллиева Гулёра Одилбековна',
    'Султанмахмудов Абдукарим Сардорович',
    'Талантбек кызы Жанылай',
    'Хамдамов Абдулазиз Хикматуллаевич',
    'Чоконбекова Каныкей Мирлановна',
    'Шалыев Исираил Алтынбекович',
    'Шарипова Айбийке Таалаевна',
    'Юлдашев Аброрбек',
    'Таалайбеков Адилет',
    'Туратбек кызы Асема',
  ],
  'АЯдНЯ-1-24': [],
  'ФМО-1-22': [],
};

const GROUP_SUBJECTS = {
  'ФМО(И)-1-24': 'Информационные системы и базы данных',
  'ПИ-1-25': ['Базы данных', 'Прикладные компьютерные программы в профессиональной деятельности'],
  'БУА-1-24': 'Экономикада математикалык методор жана моделдер',
  'АЯдНЯ-1-24': 'Информатика',
  'ФМО-1-22': 'Системы компьютерной математики',
};


async function sendToGoogleSheets(payload) {
  const photoData = payload.photo;
  const mainData = { ...payload, photo: '' };

  const url = GOOGLE_SCRIPT_URL + '?' + new URLSearchParams(mainData).toString();
  await fetch(url, { mode: 'no-cors' });

  if (photoData && photoData.length > 0) {
    try {
      await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify({ name: payload.name, photo: photoData }),
      });
    } catch (photoErr) {
      console.warn('Сүрөт жөнөтүлбөдү:', photoErr);
    }
  }
}

// ==================== СТУДЕНТ ФОРМАСЫ ====================
function StudentForm() {
  const [name, setName] = useState('');
  const [group, setGroup] = useState('');
  const [subject, setSubject] = useState('');
  const groupSubjects = group ? GROUP_SUBJECTS[group] : null;
  const subjectList = Array.isArray(groupSubjects) ? groupSubjects : groupSubjects ? [groupSubjects] : [];
  const students = group ? GROUPS[group] : [];
  const [photo, setPhoto] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!group) { setError('Группаңызды тандаңыз!'); return; }
    if (!name.trim()) { setError('Атыңызды тандаңыз!'); return; }
    if (!subject) { setError('Сабакты тандаңыз!'); return; }

    setSubmitting(true);
    setError('');
    try {
      await sendToGoogleSheets({
        name: name.trim(), group, subject, date,
        attendance: 'Келдим',
        photo: photo || '',
      });
      setSubmitted(true);
    } catch (err) {
      setError('Жөнөтүүдө ката кетти: ' + err.message);
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="card success-card">
        <div className="success-icon">&#10003;</div>
        <h2>Катышууңуз катталды!</h2>
        <p className="success-name">{name}</p>
        <p className="success-detail">{group} &middot; {subject}</p>
        <p className="success-detail">{date}</p>
        {photo && <img src={photo} alt="selfie" className="success-photo" />}
        <button className="btn btn-secondary" onClick={() => {
          setSubmitted(false); setName(''); setPhoto(null);
        }}>
          Жаңы катышуу
        </button>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="header">
        <div className="logo">
          <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M16 11l2 2 4-4"/>
          </svg>
        </div>
        <h1 className="title">Сабакка Катышуу</h1>
        <p className="subtitle">Группаңызды жана атыңызды тандаңыз</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="field">
          <label>ГРУППА:</label>
          <select value={group} onChange={(e) => {
            const g = e.target.value;
            setGroup(g); setName('');
            const subs = g ? GROUP_SUBJECTS[g] : null;
            setSubject(Array.isArray(subs) ? '' : (subs || ''));
          }} className="input">
            <option value="">-- Группаңызды тандаңыз --</option>
            {Object.keys(GROUPS).map((g) => <option key={g} value={g}>{g}</option>)}
          </select>
        </div>

        <div className="field">
          <label>СТУДЕНТТИН АТЫ-ЖОНУ:</label>
          {students.length > 0 ? (
            <select value={name} onChange={(e) => setName(e.target.value)} className="input">
              <option value="">-- Атыңызды тандаңыз --</option>
              {students.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          ) : (
            <input type="text" value={name} onChange={(e) => setName(e.target.value)}
              placeholder={group ? 'Толук атыңызды жазыңыз' : 'Адегенде группа тандаңыз'}
              className="input" disabled={!group} />
          )}
        </div>

        <div className="field">
          <label>САБАК:</label>
          {subjectList.length > 1 ? (
            <select value={subject} onChange={(e) => setSubject(e.target.value)} className="input">
              <option value="">-- Сабакты тандаңыз --</option>
              {subjectList.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          ) : (
            <div className="readonly-value">{subject || (group ? 'Сабак жок' : 'Адегенде группа тандаңыз')}</div>
          )}
        </div>

        <div className="field">
          <label>ДАТА:</label>
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="input" />
        </div>

        {/* Сүрөт */}
        <div className="field">
          <label>СҮРӨТ:</label>
          <div className="camera-section">
            {!photo ? (
              <label className="btn btn-camera file-btn">
                Сүрөткө тартуу
                <input type="file" accept="image/*" style={{ display: 'none' }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    const reader = new FileReader();
                    reader.onload = (ev) => setPhoto(ev.target.result);
                    reader.readAsDataURL(file);
                  }} />
              </label>
            ) : (
              <div className="photo-preview">
                <img src={photo} alt="selfie" className="preview-img" />
                <button type="button" className="btn btn-secondary" onClick={() => setPhoto(null)}>
                  Сүрөттү алмаштыруу
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="field">
          <label>КАТЫШУУ:</label>
          <div className="attendance-badge">Келдим</div>
        </div>

        {error && <div className="error">{error}</div>}

        <button type="submit" className="btn btn-submit" disabled={submitting}>
          {submitting ? 'Жөнөтүлүүдө...' : 'Келдим'}
        </button>
      </form>
    </div>
  );
}

// ==================== МУГАЛИМ ПАНЕЛИ ====================
function TeacherPanel() {
  const [password, setPassword] = useState('');
  const [authenticated, setAuthenticated] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statsMode, setStatsMode] = useState(false);

  const TEACHER_PASS = 'admin123';

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === TEACHER_PASS) {
      setAuthenticated(true);
    } else {
      alert('Сырсөз туура эмес!');
    }
  };

  const loadRecords = async () => {
    if (!selectedGroup) return;
    setLoading(true);
    try {
      const url = GOOGLE_SCRIPT_URL + '?' + new URLSearchParams({
        action: 'getRecords', group: selectedGroup, date: selectedDate
      }).toString();
      const res = await fetch(url);
      const data = await res.json();
      setRecords(data.records || []);
    } catch {
      setRecords([]);
    }
    setLoading(false);
  };

  const loadStats = async () => {
    if (!selectedGroup) return;
    setLoading(true);
    try {
      const url = GOOGLE_SCRIPT_URL + '?' + new URLSearchParams({
        action: 'getStats', group: selectedGroup
      }).toString();
      const res = await fetch(url);
      const data = await res.json();
      setRecords(data.stats || []);
    } catch {
      setRecords([]);
    }
    setLoading(false);
  };

  if (!authenticated) {
    return (
      <div className="card">
        <div className="header">
          <div className="logo logo-teacher">
            <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
              <line x1="8" y1="21" x2="16" y2="21"/>
              <line x1="12" y1="17" x2="12" y2="21"/>
            </svg>
          </div>
          <h1 className="title">Мугалим панели</h1>
          <p className="subtitle">Кирүү үчүн сырсөздү жазыңыз</p>
        </div>
        <form onSubmit={handleLogin}>
          <div className="field">
            <label>СЫРСӨЗ:</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Сырсөздү жазыңыз" className="input" />
          </div>
          <button type="submit" className="btn btn-submit">Кирүү</button>
        </form>
      </div>
    );
  }

  const allStudents = selectedGroup ? GROUPS[selectedGroup] : [];
  const presentNames = records.map(r => r.name);
  const absentStudents = statsMode ? [] : allStudents.filter(s => !presentNames.includes(s));

  return (
    <div className="card teacher-card">
      <div className="header">
        <h1 className="title">Мугалим панели</h1>
        <p className="subtitle">Катышуу маалыматтары</p>
      </div>

      <div className="teacher-tabs">
        <button className={`tab ${!statsMode ? 'tab-active' : ''}`} onClick={() => setStatsMode(false)}>
          Бүгүнкү катышуу
        </button>
        <button className={`tab ${statsMode ? 'tab-active' : ''}`} onClick={() => setStatsMode(true)}>
          Статистика
        </button>
      </div>

      <div className="field">
        <label>ГРУППА:</label>
        <select value={selectedGroup} onChange={(e) => { setSelectedGroup(e.target.value); setRecords([]); }} className="input">
          <option value="">-- Группа тандаңыз --</option>
          {Object.keys(GROUPS).map((g) => <option key={g} value={g}>{g}</option>)}
        </select>
      </div>

      {!statsMode && (
        <div className="field">
          <label>ДАТА:</label>
          <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} className="input" />
        </div>
      )}

      <button type="button" className="btn btn-submit" onClick={statsMode ? loadStats : loadRecords}
        disabled={!selectedGroup || loading}>
        {loading ? 'Жүктөлүүдө...' : statsMode ? 'Статистиканы көрүү' : 'Маалыматтарды жүктөө'}
      </button>

      {/* Жыйынтыктар */}
      {records.length > 0 && !statsMode && (
        <div className="results">
          <div className="results-header">
            <span className="present-count">Келгендер: {presentNames.length}</span>
            <span className="absent-count">Келбегендер: {absentStudents.length}</span>
          </div>

          <div className="result-section">
            <h3 className="section-title section-present">Келгендер</h3>
            {records.map((r, i) => (
              <div key={i} className="student-row present">
                <span className="student-num">{i + 1}</span>
                <div className="student-info">
                  <span className="student-name">{r.name}</span>
                  <span className="student-meta">{r.time} &middot; {r.distance || '?'}м</span>
                </div>
                <span className="status-dot dot-present" />
              </div>
            ))}
          </div>

          {absentStudents.length > 0 && (
            <div className="result-section">
              <h3 className="section-title section-absent">Келбегендер</h3>
              {absentStudents.map((s, i) => (
                <div key={i} className="student-row absent">
                  <span className="student-num">{i + 1}</span>
                  <div className="student-info">
                    <span className="student-name">{s}</span>
                  </div>
                  <span className="status-dot dot-absent" />
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Статистика */}
      {records.length > 0 && statsMode && (
        <div className="results">
          <h3 className="section-title" style={{ marginBottom: 12 }}>Катышуу статистикасы</h3>
          {records.map((r, i) => (
            <div key={i} className="stat-row">
              <div className="stat-info">
                <span className="student-name">{r.name}</span>
                <span className="stat-detail">{r.present}/{r.total} сабак</span>
              </div>
              <div className="stat-bar-bg">
                <div className="stat-bar" style={{ width: `${r.percent}%` }} />
              </div>
              <span className={`stat-percent ${r.percent >= 70 ? 'stat-good' : 'stat-bad'}`}>
                {r.percent}%
              </span>
            </div>
          ))}
        </div>
      )}

      <button className="btn btn-secondary" style={{ marginTop: 16 }}
        onClick={() => setAuthenticated(false)}>
        Чыгуу
      </button>
    </div>
  );
}

// ==================== НЕГИЗГИ APP ====================
function App() {
  const [page, setPage] = useState('student');

  return (
    <div className="container">
      <div className="app-wrapper">
        <div className="page-tabs">
          <button className={`page-tab ${page === 'student' ? 'page-tab-active' : ''}`}
            onClick={() => setPage('student')}>
            Студент
          </button>
          <button className={`page-tab ${page === 'teacher' ? 'page-tab-active' : ''}`}
            onClick={() => setPage('teacher')}>
            Мугалим
          </button>
        </div>

        {page === 'student' ? <StudentForm /> : <TeacherPanel />}
      </div>
    </div>
  );
}

export default App;
